import { render, staticRenderFns } from "./DrawerOutcomeNote.vue?vue&type=template&id=467e8fb2&scoped=true"
import script from "./DrawerOutcomeNote.vue?vue&type=script&lang=js"
export * from "./DrawerOutcomeNote.vue?vue&type=script&lang=js"
import style0 from "./DrawerOutcomeNote.vue?vue&type=style&index=0&id=467e8fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e8fb2",
  null
  
)

export default component.exports